import BugReportIcon from '@mui/icons-material/BugReport';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';

interface LauncherButtonProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const LauncherButton: React.FC<LauncherButtonProps> = ({ isOpen, onToggle }) => {
  return (
    <Box
      data-no-invert="true"
      sx={{
        position: 'fixed',
        bottom: { xs: 90, sm: 84 },
        right: { xs: 16, sm: 24 },
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
      }}
    >
      <Tooltip title={isOpen ? 'Close' : 'Report a Bug'} placement="left">
        <IconButton
          id="qa-bug-widget-button"
          onClick={onToggle}
          aria-label="Report a Bug"
          sx={{
            width: 52,
            height: 52,
            borderRadius: '50%',
            border: '1px solid',
            borderColor: '#e5e7eb',
            backgroundColor: '#ffffff',
            color: '#0F9A00',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              backgroundColor: '#EFFFF3',
            },
          }}
        >
          {isOpen ? <CloseIcon sx={{ fontSize: 24 }} /> : <BugReportIcon sx={{ fontSize: 26 }} />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
